import { render } from "./vmenuedit.vue?vue&type=template&id=4f47c6b8&scoped=true"
import script from "./vmenuedit.vue?vue&type=script&lang=js"
export * from "./vmenuedit.vue?vue&type=script&lang=js"

import "./vmenuedit.vue?vue&type=style&index=0&id=4f47c6b8&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f47c6b8"]])

export default __exports__